import { FontSizes, Radius, Spacings } from '@picsart/cascade';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
  secondImage: {
    '--current-value': props => props?.value,
    willChange: 'clip-path',
    position: 'absolute',
    left: 0,
    top: 0,
    background: 'var(--transparent-background-image)',
    width: '100%',
    height: '100%',
    pointerEvents: 'none',
    clipPath: `inset(0%
      calc(
        100% -
        (1% * var(--current-value) / var(--image-scale)) -
        (1% * var(--image-box-scroll-left)) +
        (1% * var(--image-box-scroll-left) / var(--image-scale))
      ) 0% 0%)`,
  },
  beforeAfterWrapper: {
    position: 'absolute',
    pointerEvents: 'none',
    width: '100%',
    height: '100%',
    top: 0,
  },
  labelText: {
    height: 20,
    backgroundColor: 'rgba(18, 18, 18, 0.70)',
    padding: `${Spacings.s2} ${Spacings.s12}`,
    color: 'white',
    borderRadius: Radius.r12,
    display: 'flex',
    fontSize: FontSizes.s12,
    alignItems: 'center',
    justifyContent: 'center',
  },
  rangeBox: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
  },
  lineIndicator: {
    '--current-value': props => props?.value,
    position: 'absolute',
    width: '100%',
    height: '100%',
    '--line-width': '2px',
    '--x-pos': 'calc((var(--current-value) * 100%) / 100 - (var(--line-width) / 2))',
    transform: 'translateX(var(--x-pos))',
    '&:before': {
      content: '""',
      display: 'block',
      width: 'var(--line-width)',
      height: '100%',
      background: '#fff',
      willChange: 'transform',
      pointerEvents: 'none',
    },
  },
  slicer: {
    '--thumb-size': '20px',
    backgroundColor: 'transparent',
    pointerEvents: 'none',
    WebkitAppearance: 'none',
    appearance: 'none',
    position: 'absolute',
    width: 'calc(100% + var(--thumb-size))',
    marginLeft: 'calc(-1 * var(--thumb-size) / 2)',
    height: '100%',
    '-webkit-appearance': 'none',
    '&::-webkit-slider-thumb': {
      width: 'var(--thumb-size)',
      height: 'var(--thumb-size)',
      background: '#fff',
      borderRadius: '50%',
      transform: 'translate3d(0, 0, 0)',
      cursor: 'ew-resize',
      pointerEvents: 'initial',
      WebkitAppearance: 'none',
      appearance: 'none',
    },
    '&::-moz-range-thumb': {
      width: 'var(--thumb-size)',
      height: 'var(--thumb-size)',
      background: '#fff',
      borderRadius: '50%',
      transform: 'translate3d(0, 0, 0)',
      cursor: 'ew-resize',
      pointerEvents: 'initial',
      appearance: 'none',
    },
  },
});

export default useStyles;
